import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const Error = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M23 28H9C6.237 28 4 25.762 4 23C4 22.137 4.225 21.275 4.65 20.525L11.663 6.5C12.55 4.963 14.213 4 15.988 4C17.763 4 19.426 4.963 20.313 6.5L27.325 20.525C27.75 21.275 27.975 22.138 27.975 23C28 25.762 25.763 28 23 28ZM13.412 7.475L6.399 21.5C6.136 21.95 5.999 22.475 5.999 23C5.999 24.65 7.349 26 8.999 26H22.999C24.649 26 25.999 24.65 25.999 23C25.999 22.475 25.862 21.95 25.599 21.5L18.587 7.475C18.049 6.563 17.062 6 16 6C14.938 6 13.95 6.563 13.412 7.475V7.475Z" />
		<path d="M17 21C17 21.552 16.552 22 16 22C15.448 22 15 21.552 15 21C15 20.448 15.448 20 16 20C16.552 20 17 20.448 17 21Z" />
		<path d="M16 18C15.45 18 15 17.55 15 17V13C15 12.45 15.45 12 16 12C16.55 12 17 12.45 17 13V17C17 17.55 16.55 18 16 18Z" />
	</svg>
);

export default Error;
